export default __webpack_public_path__ + "static/media/time-line-active-moblie.5a908ca7.svg";